import { isArray, isNumber, isObject, toNumber } from "lodash";
import { useHintCardStore } from "@/src/stores/useHintCardStore";
import { useEffect, useMemo } from "react";
import { ProposalTable as ProposalTableUI } from "./ProposalTable";
import { useFormContext } from "react-hook-form";
import { DAYS_ABROAD_CONST, ProposalTableColumnsKeys } from "../lib/const";

export function ProposalTable(props: any) {
  const columns = isArray(props?.columns) ? props.columns : [];
  const rows = isArray(props?.rows) ? props.rows : [];
  const pdfFile = isObject(props?.pdfFile) ? props.pdfFile : {};
  const hidden = !!props?.hidden;

  const setHintsList = useHintCardStore((state) => state.setHintsList);
  const { watch } = useFormContext();

  const watchedDaysAbroad = watch(DAYS_ABROAD_CONST);

  useEffect(() => {
    const hintList = rows.reduce((acc: any, item: any) => {
      if (item?.hint) {
        acc.push({ ...item.hint, contentTitle: item?.title });
      }
      return acc;
    }, []);
    setHintsList(hintList);
  }, [rows, setHintsList]);

  const filteredColumns = useMemo(() => {
    const daysAbroadValue = toNumber(watchedDaysAbroad);
    if (!isNumber(daysAbroadValue)) {
      return columns;
    }

    return columns.filter((col: any) => {
      if (daysAbroadValue <= 2) {
        return (
          col.title !== ProposalTableColumnsKeys.Vip &&
          col.title !== ProposalTableColumnsKeys.Standard
        );
      }
      if (daysAbroadValue < 31) {
        return col.title !== ProposalTableColumnsKeys.Vip;
      }
      if (daysAbroadValue >= 31) {
        return col.title !== ProposalTableColumnsKeys.Elit;
      }
      return true;
    });
  }, [columns, watchedDaysAbroad]);

  return (
    <ProposalTableUI
      pdfFile={pdfFile}
      hidden={hidden}
      columns={filteredColumns}
      rows={rows}
      columnName={"pickedTravelCalculationCategory"}
    />
  );
}
